import * as moment from 'moment';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './tax-details.reducers';
import { TaxDetailsDataResponse, TaxDetailsFilter } from './tax-details.models';
import { CommonConstants, DatesInterval, FinancialYearDatesInterval } from '../../global/interfaces';
import { getTaxDetailsYearsDropdownValues } from '../../global/dates';
import { isNullOrUndefined } from 'util';
import { selectAuthUserFinancialYearStartMonth } from '../auth/auth.selectors';

export const selectTaxDetailsState = createFeatureSelector<State>('taxDetails');

export const selectTaxDetailsLoading = createSelector(selectTaxDetailsState, (state: State) => state.loading);

export const selectTaxDetailsFilter = createSelector(selectTaxDetailsState, (state: State) => state.filter);


export const selectTaxDetailsYearFilter = createSelector(selectTaxDetailsFilter, (state?: TaxDetailsFilter) => state
    ? state.year : undefined);
export const selectTaxDetailsMonthFilter = createSelector(selectTaxDetailsFilter, (state?: TaxDetailsFilter) => state
    ? state.month : undefined);
export const selectTaxDetailsDateFilter = createSelector(selectTaxDetailsFilter, (state?: TaxDetailsFilter) => state
    ? state.date : undefined);

export const selectTaxDetailsDates = createSelector(selectTaxDetailsState, (state?: State) => state ? state.dates : undefined);

export const selectTaxDetailsDatesMin = createSelector(selectTaxDetailsDates, (dates?: DatesInterval) =>
    dates ? moment.utc(dates.min) : undefined
);

export const selectTaxDetailsDatesMax = createSelector(selectTaxDetailsDates, (dates?: DatesInterval) =>
    dates ? moment.utc(dates.max) : undefined
);

export const selectTaxDetailsfinancialYearDate = createSelector(selectTaxDetailsState,
    (state?: State) => state ? state.financialYearDate : undefined);

export const selectTaxDetailsFinancialEndDate = createSelector(selectTaxDetailsfinancialYearDate,
    (financialyearDate?: FinancialYearDatesInterval) => financialyearDate ? moment.utc(financialyearDate.endDateofFinancilaYear) : undefined
);

export const selectTaxDetailsFinancialStartDate = createSelector(selectTaxDetailsfinancialYearDate,
    (financialyearDate?: FinancialYearDatesInterval) => financialyearDate ?
        moment.utc(financialyearDate.startDateofFinancialYear) : undefined
);
export const selectTaxDetailsYears = createSelector(
    selectTaxDetailsDatesMin,
    selectTaxDetailsDatesMax,
    selectAuthUserFinancialYearStartMonth,
    (min?: moment.Moment, max?: moment.Moment, financialYearmonth?: any) =>
        getTaxDetailsYearsDropdownValues(min, max, financialYearmonth)
);

export const selectTaxDetailsSort = createSelector(selectTaxDetailsState, (state: State) => state.sort);

export const selectTaxDetailsResponse = createSelector(selectTaxDetailsState, (state: State) => state.data);

export const selectTaxDetailsData = createSelector(selectTaxDetailsResponse, (state: TaxDetailsDataResponse) => {
    if (!isNullOrUndefined(state) && !isNullOrUndefined(state.taxDetailsData) && state.taxDetailsData.length > 0) {
        return state.taxDetailsData;
    }
});

export const selectTaxDetailsTotal = createSelector(selectTaxDetailsResponse, (state: TaxDetailsDataResponse) => {
    if (!isNullOrUndefined(state) && !isNullOrUndefined(state.total)) {
        return state.total;
    }
});

export const selectTaxDetailsPIR = createSelector(selectTaxDetailsResponse, (state: TaxDetailsDataResponse) => {
    if (!isNullOrUndefined(state) && !isNullOrUndefined(state.pir)) {
        return state.pir;
    }
});


